// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Alert, Box, Button, Grid, Dialog, DialogContent, DialogActions } from '@mui/material';

// TODO: Import MUI icon
import { Calculate, People, TextSnippet, Translate, EscalatorWarning, Fort, Public, Computer, Science, MenuBook } from '@mui/icons-material';

// TODO: Import context

// TODO: Import custom component
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

import BoxSubPage from '../Common/BoxSubPage';

const S1StudyTips = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component S1StudyTips Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const [url, setUrl] = React.useState('');

    const fontSize = 16;
    const iconSize = 28;

    // TODO: Define event
    const handleOpenDialog = (url) => { setUrl(url); };

    // TODO: Return component
    return (
        <BoxSubPage
            disableMenu={true}
            disableSubtitle={true}
            id="S1StudyTips"
            title="中一溫習錦囊"
        >
            <Box sx={{
                backgroundColor:'white',
                backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/background.jpg)`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right bottom',
                backgroundSize: '800px 800px',
                height: '95vh',
                maxWidth: '800px',
            }}>
                <Alert severity="info" sx={{ m: 1 }}>
                    {Text.LearningAndTeacher.S1StudyTips.Description[language]}
                </Alert>
                <Grid container spacing={2} sx={{ padding: 1 }}>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<Translate sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#713F12', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/chi.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.CHI[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<MenuBook sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#6C5CE7', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/eng.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.ENG[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<Calculate sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#2B6CB0', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/math.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.MATH[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<People sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#1E3A8A', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/cs.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.CES[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<TextSnippet sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#9A3412', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/pth.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.PTH[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<EscalatorWarning sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#5C1229', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/chist.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.CHIST[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<Fort sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#4C1D95', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/hist.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.HIST[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<Public sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#0F766E', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/geo.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.GEO[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<Computer sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#2563EB', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/ict.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.ICT[language]}
                        </Button>
                    </Grid>
                    <Grid size={6}>
                        <Button
                            fullWidth
                            startIcon={<Science sx={{ width: iconSize, height: iconSize }} />}
                            sx={{ fontSize: fontSize, height: 64, backgroundColor: '#0284C7', borderRadius: '20px' }}
                            variant="contained"
                            onClick={() => handleOpenDialog('https://www.pohtyh.edu.hk/SADCPlatform2/Files/LearningAndTeaching/S1StudyTips/is.html')}
                        >
                            {Text.LearningAndTeacher.S1StudyTips.Subject.IS[language]}
                        </Button>
                    </Grid>
                </Grid>
                <Dialog maxWidth="lg" fullWidth open={Boolean(url)} onClose={() => setUrl('')}>
                    <DialogContent sx={{ p: 0 }}>
                        <iframe src={url} width="100%" style={{ height: '75vh' }} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => handleOpenDialog('')}>{Text.Common.Close[language]}</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </BoxSubPage>
    );
}
export default S1StudyTips;